/* global $, $R, API */

$R.add('plugin', 'media', {
  /**
   * Initialize the plugin, this will add buttons, modals etc.
   * @return {void}
   */
  init(app) {
    this.toolbar = app.toolbar;
    this.app = app;
  },

  start() {
    const $button = this.toolbar.addButton('media-button', {
      title: 'Media',
      api: 'plugin.media.show',
    });

    $button.setIcon('<i class="re-icon-image"></i>');
  },

  /**
   * Retrieve media items by id
   * @param {Array} ids
   * @return {Promise}
   */
  getMedia(ids) {
    return Promise.all(ids.map(id => (
      window.axios.get(`${API.media.getMediaUrl}/${id}`)
        .then(data => data.data)
    )));
  },

  /**
   * Change the media path to a resized one
   * @param {String} path
   * @return {String}
   */
  pathToResized(path) {
    const parts = path.split('/');
    const filename = parts[parts.length - 1];

    parts.pop();

    return `/${parts.join('/')}/content_image/${filename}`;
  },

  /**
   * Output media items into Redactor
   * @param {Array} arr
   * @param {Number} offset
   * @return {void}
   */
  outputMedia(arr, offset = 0) {
    this.app.offset.set({ start: offset, end: offset });

    setTimeout(() => {
      arr.forEach((item) => {
        const { id } = item;

        this.app.api('module.image.insert', {
          [id]: {
            id,
            url: this.pathToResized(item.path),
          },
        });
      });
    }, 10);
  },

  /**
   * Called on clicking the Redactor button
   * @return {void}
   */
  show() {
    // Create unique id to know in which editor to insert the media after selection
    const uuid = Math.round(Math.random() * 100000) + 99999;
    const offset = this.app.offset.get();

    const endOffset = typeof offset !== 'undefined' && typeof offset.end !== 'undefined' ? offset.end : 0;

    // Listen for selections inside the media browser
    $(document).on('browser:selected', (e, obj) => {
      // If the id matches the unique id we've made up
      if (obj.id === `redactor:${uuid}`) {
        // Retrieve all media items by id
        this.getMedia(obj.selected)
          .then((arr) => {
            this.outputMedia(arr, endOffset);
          });
      }
    });

    // Open media browser
    $(document).trigger('browser:open', `redactor:${uuid}`);
  },
});
